import React, { useEffect, useState } from 'react';
import { useSound } from './SoundEffects';
export const EnhancedLoadingScreen = ({
  onLoadingComplete
}) => {
  const [progress, setProgress] = useState(0);
  const {
    playSound
  } = useSound();
  useEffect(() => {
    // Progress timer - increases progress over 5 seconds (shortened from 10)
    const totalDuration = 5000; // 5 seconds in milliseconds
    const interval = 50; // Update every 50ms for smooth animation
    const incrementAmount = interval / totalDuration * 100;
    const timer = setInterval(() => {
      setProgress(prevProgress => {
        const newProgress = prevProgress + incrementAmount;
        // Play progress sound at certain points
        if (Math.floor(newProgress) % 25 === 0 && Math.floor(newProgress) > 0) {
          playSound('notification');
        }
        // Complete loading when we reach 100%
        if (newProgress >= 100) {
          clearInterval(timer);
          setTimeout(() => {
            onLoadingComplete();
          }, 500);
          return 100;
        }
        return newProgress;
      });
    }, interval);
    return () => clearInterval(timer);
  }, [onLoadingComplete, playSound]);
  return <div className="fixed inset-0 bg-[#030508] z-50 flex flex-col items-center justify-center" data-id="element-731">
      <style jsx global data-id="element-732">{`
        .scan-line {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 100%;
          background: linear-gradient(
            to bottom,
            transparent,
            rgba(111, 248, 240, 0.2),
            transparent
          );
          opacity: 0;
          animation: scan-animation 3s linear infinite;
          pointer-events: none;
        }
        @keyframes scan-animation {
          0% {
            top: -100%;
            opacity: 0.3;
          }
          100% {
            top: 100%;
            opacity: 0.3;
          }
        }
        .loading-progress-bar {
          position: relative;
          overflow: hidden;
          border-radius: 999px;
        }
        .loading-progress-glow {
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          width: 20px;
          background: linear-gradient(
            90deg,
            rgba(111, 248, 240, 0) 0%,
            rgba(111, 248, 240, 1) 100%
          );
          filter: blur(5px);
          opacity: 0.8;
          border-radius: 999px;
        }
        .loading-circuit-lines {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
          opacity: 0.15;
          pointer-events: none;
        }
        .loading-circuit-line {
          position: absolute;
          background: linear-gradient(
            90deg,
            rgba(111, 248, 240, 0) 0%,
            rgba(111, 248, 240, 1) 50%,
            rgba(111, 248, 240, 0) 100%
          );
          height: 1px;
        }
        .loading-circuit-line-1 {
          top: 20%;
          left: 0;
          right: 0;
          animation: circuit-line-anim 15s infinite linear;
        }
        .loading-circuit-line-2 {
          top: 60%;
          left: 0;
          right: 0;
          animation: circuit-line-anim 20s infinite linear;
          animation-delay: 5s;
        }
        .loading-circuit-line-3 {
          top: 80%;
          left: 0;
          right: 0;
          animation: circuit-line-anim 12s infinite linear;
          animation-delay: 2s;
        }
        @keyframes circuit-line-anim {
          0% {
            opacity: 0;
            background-position: -100% 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            background-position: 200% 0;
          }
        }
      `}</style>
      {/* Circuit lines */}
      <div className="loading-circuit-lines" data-id="element-733">
        <div className="loading-circuit-line loading-circuit-line-1" data-id="element-734"></div>
        <div className="loading-circuit-line loading-circuit-line-2" data-id="element-735"></div>
        <div className="loading-circuit-line loading-circuit-line-3" data-id="element-736"></div>
      </div>
      <div className="relative mb-8 z-30" data-id="element-737">
        <div data-id="element-738">
          <h1 className="text-[#6ff8f0] text-4xl md:text-5xl font-heading animate-pulse-subtle" data-id="element-739">
            CHERYL QIAN
          </h1>
        </div>
        <div className="absolute -inset-1 bg-[#6ff8f0] opacity-20 blur-md animate-pulse" data-id="element-740"></div>
        <div className="scan-line" data-id="element-741"></div>
      </div>
      <div className="w-64 h-1 bg-[#1a2a40] overflow-hidden rounded-full mb-4 loading-progress-bar" data-id="element-742">
        <div className="h-full bg-gradient-to-r from-[#6ff8f0] to-[#e64cff]" style={{
        width: `${progress}%`
      }} data-id="element-743">
          <div className="loading-progress-glow" style={{
          transform: `translateX(${progress}%)`
        }} data-id="element-744"></div>
        </div>
      </div>
    </div>;
};